// extracted by mini-css-extract-plugin
export default {"container":"PrivacyStatementPage_container__ZZBU1","highlightedText":"PrivacyStatementPage_highlightedText__+YX-b"};